module.exports = __webpack_public_path__ + "media/images/patterns/4-05ab6aed8e0c3219eb971a1971572278.png";